import React from 'react';
import {useField} from 'formik';
import {useIntl} from 'react-intl';
import InputEmailChips from '../../../../common/components/ui/InputEmailChips';
import {useOrderInvoiceFormContext} from "../../contexts/OrderInvoiceFormContext";

const FieldEmailRecipients = () => {
  const intl = useIntl();
  const labelText = intl.formatMessage({
    id: 'orderInvoice-form-emailRecipients',
    defaultMessage: 'Emails'
  });
  const placeholder = intl.formatMessage({
    id: 'default-placeholder',
    defaultMessage: 'Write here'
  });
  const [field, meta, helpers] = useField({name: 'emails'});
  const {showAllErrors} = useOrderInvoiceFormContext();

  return (
    <InputEmailChips
      {...field}
      {...meta}
      id={field.name}
      label={labelText}
      defaultValue={field.value}
      placeholder={placeholder}
      onChange={helpers.setValue}
      showErrorOnSubmit={showAllErrors}
    />
  );
};

export default FieldEmailRecipients;
